import Vue from 'vue';
import Router from 'vue-router';
import CleanViewPanelRoutes from '@/app/cleanViewPanel/config/routes';
import GeneralPanelRoutes from '@/app/generalPanel/config/routes';
import InstallationRoutes from '@/app/installation/config/routes';
import LoginRoutes from '@/app/login/config/routes';
import ActiveDirectoryRoutes from '@/app/activeDirectory/config/routes';
import UserRoutes from '@/app/user/config/routes';
import MySigmaRoutes from '@/app/generalPanel/mySigma/config/routes';

export const HOME_ROUTE = { name: 'dashboard' };
export const LOGIN_ROUTE = { name: 'sign-in' };

const routes = [
  GeneralPanelRoutes,
  MySigmaRoutes,
  InstallationRoutes,
  LoginRoutes,
  ActiveDirectoryRoutes,
  UserRoutes,
  CleanViewPanelRoutes,
];

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const PlaygroundRoutes = require('../../dev/playground/routes').default;
  routes.push(...PlaygroundRoutes);
}

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router);
}

const router = new Router({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;

/**
 * Obtem a configuração de query string para retornar a uma rota.
 * Para que uma rota não seja "retornável", adicione "noReturnTo = true" no meta da rota.
 * @param {*} route Rota para ser retornada.
 * @returns {Object} Configuração de query string para o roteador do Vue.
 */
export function getReturnToQueryString(route) {
  if (route.name === LOGIN_ROUTE.name || route.name === HOME_ROUTE.name) {
    return null;
  }

  if ((route.meta && route.meta.noReturnTo)) {
    return null;
  }

  return { returnTo: route.fullPath };
}

/**
 * Obtem a rota para iniciar uma sessão após logar.
 * Se houver rota de retorno, será essa rota, caso contrário, será a Home geral.
 * @returns {Object} Rota.
 */
export function getRouteToStartSession() {
  if (router.currentRoute.query && router.currentRoute.query.returnTo) {
    return router.currentRoute.query.returnTo;
  }

  return HOME_ROUTE;
}
